// useForm.js

import { useState, useEffect } from 'react';
import {  getVendorLedgerDetails } from '../../Service/ApiService';
const VendorLedgerDetailsController = () => {
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const storedLedgerData = JSON.parse(localStorage.getItem('ledgerData'));

  
  useEffect(() => {
    fetchLedgerDetailsData();
  }, []);


  const fetchLedgerDetailsData = async () => {
    try {
      setcLoading(true);
      const response = await getVendorLedgerDetails(
        storedLedgerData.partyCode,
        storedLedgerData.month,
        storedLedgerData.year,
        storedLedgerData.opening
      );
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.data);
      } else {
        setLedgerData([]);
      }
      setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
    }
  };

  
  return {
    ledgerData,
    cloading,
  };
};

export default VendorLedgerDetailsController;
